import React from 'react';
import I18n from '@/modules/i18n';
import LessonSection from './LessonSection';
import UnitSlideShowCards from './Cards/UnitSlideShowCards';
import type { SlideShow } from './Cards/UnitSlideShowCard/UnitSlideShowCardTypes';

interface NewUnitOverviewProps {
  programId: number;
  slideShowsAbove: SlideShow[];
  slideShowsBelow: SlideShow[];
  unitColor: string;
  unitId: number;
}

const NewUnitOverview = ({
  programId,
  slideShowsAbove,
  slideShowsBelow,
  unitColor,
  unitId,
}: NewUnitOverviewProps) => (
  <>
    <div className="tw-ml-10 tw-relative">
      <h2 className="tw-my-2 tw-text-2xl tw-align-middle tw-leading-8">
        {I18n.t('content')}
      </h2>
    </div>
    <UnitSlideShowCards
      programId={programId}
      slideShows={slideShowsAbove}
      unitColor={unitColor}
      unitId={unitId}
    />
    <LessonSection
      programId={programId}
      unitColor={unitColor}
      unitId={unitId}
    />
    <UnitSlideShowCards
      programId={programId}
      slideShows={slideShowsBelow}
      unitColor={unitColor}
      unitId={unitId}
    />
  </>
);

export default NewUnitOverview;
